module.exports = __webpack_public_path__ + "static/media/AnimalVet1.b3442ae2.jpg";